import { render, staticRenderFns } from "./zhongben.vue?vue&type=template&id=6abe5fa9"
import script from "./zhongben.vue?vue&type=script&lang=ts"
export * from "./zhongben.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports